import { render, staticRenderFns } from "./BizLineManage.vue?vue&type=template&id=24dc1ce5&scoped=true&"
import script from "./BizLineManage.vue?vue&type=script&lang=js&"
export * from "./BizLineManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc1ce5",
  null
  
)

export default component.exports